import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User_BrUser } from "../../../data/models/User/User_BrUser";

type Nullable<T> = T | null;

type CurrentUserState = {
    currentUser : Nullable<User_BrUser>;
}

const initialState : CurrentUserState = {
    currentUser : null
}

export const currentUserSlice = createSlice({
    name: 'currentUser',
    initialState: initialState,
    reducers: {
        updateCurrentUser: (state, action : PayloadAction<User_BrUser | null>) => {
            state.currentUser = action.payload;
        },
        updateStripeSubscriptionId: (state, action : PayloadAction<string>) => {
            state.currentUser!.stripeSubscriptionId = action.payload;
        },   
        updateFirebaseAuthToken: (state, action : PayloadAction<string>) => {
            state.currentUser!.firebaseAuthToken = action.payload;
        },       }
});

export const {
    updateCurrentUser,
    updateStripeSubscriptionId,
    updateFirebaseAuthToken
} = currentUserSlice.actions;

export default currentUserSlice.reducer;